import { Info } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Eyebrow, Reveal, SectionTitle } from "./Primitives";

export const Problem = () => {
  const { content } = useSite();
  const pr = content.problem;
  if (!pr) return null;
  return (
    <section data-testid="problem-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <Eyebrow>{pr.eyebrow}</Eyebrow>
              <SectionTitle>{pr.title}</SectionTitle>
              <p className="t-body mt-6 max-w-md text-sage">{pr.intro}</p>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-7">
          <ol className="divide-y divide-forest/10 border-y border-forest/10">
            {(pr.points || []).map((pt, i) => (
              <li key={pt.title}>
                <Reveal delay={i * 0.06} className="group flex gap-6 py-7 sm:gap-10 sm:py-9">
                  <span className="text-2xl font-extrabold text-gold sm:text-3xl">0{i + 1}</span>
                  <div>
                    <h3 className="t-h3 text-forest transition-transform duration-500 group-hover:translate-x-1">{pt.title}</h3>
                    <p className="t-body mt-2 text-sage">{pt.text}</p>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
          {pr.note && (
            <p data-testid="problem-note" className="mt-8 flex gap-3 rounded-2xl bg-sand p-5 text-[15px] font-medium leading-relaxed text-ink">
              <Info className="mt-0.5 h-4 w-4 shrink-0 text-leaf" aria-hidden />{pr.note}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
